import { render } from "./EditDash.vue?vue&type=template&id=2da806a6&scoped=true"
import script from "./EditDash.vue?vue&type=script&lang=js"
export * from "./EditDash.vue?vue&type=script&lang=js"

import "./EditDash.vue?vue&type=style&index=0&id=2da806a6&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da806a6"]])

export default __exports__